export default 'AIzaSyCdX9Xo-LlmyDcm3nfOhgEIXxTgCPGnbl0'
